<div class="calculated-info-card-container">
  <div class="calculated-info-date">
    <div class="calculated-info-date-title">
      <span>
        <img src="wealth-assets/svg/date.svg" />
      </span>
      <span>بازه محاسبه سود</span>
    </div>
    <div class="calculated-info-date-value">
      <span>{{ fromDate | jalaliDate }}</span>
      <span>تا</span>
      <span>{{ toDate | jalaliDate }}</span>
    </div>
  </div>
  <div class="calculated-info-amount">
    <div class="calculated-info-amount-title">
      <span>
        <img src="wealth-assets/svg/cash.svg" />
      </span>
      <span>مبلغ سرمایه‌گذاری</span>
    </div>
    <div class="calculated-info-amount-value">
      <span>{{ amount | number }}</span>
      <span class="is-currency">ریال</span>
    </div>
  </div>
  <div class="calculated-info-recalculate">
    <span (click)="onRecalculate()"> محاسبه دوباره سود </span>
  </div>
</div>
